/* gero-gold.js — scroll reveals + gentle parallax floats (no dependencies). */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  // 1) Scroll-reveal the big homepage sections that do not animate themselves.
  var selector = [
    '#MainContent .section > .page-width',
    '#MainContent .collapsible-content',
    '#MainContent .newsletter',
    '#MainContent .featured-blog',
    '#MainContent .countdown'
  ].join(',');

  var targets = Array.prototype.slice.call(document.querySelectorAll(selector))
    .filter(function (el) {
      return !el.closest('.section--rocket-launch') &&
        !el.closest('#science-stack') &&
        !el.closest('.shopify-section-announcement-bar') &&
        !el.closest('.section-header') &&
        !el.closest('.section-footer') &&
        !el.closest('.section-marquee');
    });

  if ('IntersectionObserver' in window && targets.length) {
    targets.forEach(function (el) { el.classList.add('gero-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('gero-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  // 2) Gentle float on product imagery inside content sections (not the hero).
  var floats = document.querySelectorAll(
    '#MainContent img[src*="Mockup"], #MainContent img[src*="picture-"], #MainContent img[src*="gero1AndPills"], #MainContent img[src*="gero2."]'
  );
  floats.forEach(function (img, i) {
    img.style.animation = 'gero-float ' + (5 + (i % 3)) + 's ease-in-out ' + (i * 0.35) + 's infinite alternate';
  });
  var style = document.createElement('style');
  style.textContent = '@keyframes gero-float{from{transform:translateY(0)}to{transform:translateY(-9px)}}';
  document.head.appendChild(style);
})();
